import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import OneColumnB from '../components/OneColumnB/OneColumnB';
import PdfComponent from '../components/Pdfs/PdfComponent';
import ConcussionPolicyForm25 from "../documents/policyC25.pdf";


const Policies = () => {
return(
<div>
    <Navbar />
    <div className="section__padding app__background-gy">
        <div className="app__content">
            <h1 className="headtext__roboto">Policies</h1>
        </div>
        <div className="app__background-gy">
                    <OneColumnB
                        subtitle="Orion FC Concussion"
                        subheader="(Enacted 08/17/25)"
                        paragraph="
                        A concussion is a brain injury. Concussions are caused by a bump or blow to the head. You can’t
                        see a concussion. If your child/player reports any symptoms of concussion, or if you notice the
                        symptoms yourself, seek medical attention right away.
                        Most athletes who have a concussion are able to recover completely and return to competitive
                        play. But recovering completely from a concussion is not the same as recovering from other
                        injuries. Some symptoms of a concussion may go away fairly soon — sometimes even within hours of the 
                        injury — while other symptoms may not appear until days or even weeks later.Our program is designed 
                        to prepare you for success in high school soccer and beyond. 
                        By participating in our program, you'll gain the confidence, discipline, and teamwork skills necessary 
                        to thrive in competitive soccer. Whether your goal is to make the varsity team, earn a college scholarship, 
                        or pursue a professional career, our program will equip you with the skills and opportunities to achieve your aspirations. "
                    />
                    <div className="list">
                        <h3 className="h3__roboto-w ">Signs and Symtpoms of Concussion:</h3>
                         <div className="flexList">
                            <div className="list">
                                <h4 className="p__opensans-tryout">1. Signs observed by Coach, Parent/Guardian</h4>
                                <ul className="p__list">
                                    <li>Appears dazed or stunned</li>
                                    <li>Is confused about assignment or position</li>
                                    <li>Forgets and instruction</li>
                                    <li>Is unsure of game, score, or opponent</li>
                                    <li>Moves clumsily</li>
                                    <li>Answers questions slowly</li>
                                    <li>Loses consciousness (even briefly)</li>
                                    <li>Shows behavior or personality changes</li>
                                    <li>Can’t recall events prior to hit or fall</li>
                                    <li>Can’t recall events after hit or fall</li>
                                </ul>
                            </div>
                            <div className="">
                                <h4 className="p__opensans-tryout">2. Symptoms Reported by Athlete</h4>
                                <ul className="p__list">
                                    <li>Headache or “pressure” in head</li>
                                    <li>Nausea or vomiting</li>
                                    <li>Balance problem or dizziness</li>
                                    <li>Double or blurry vision</li>
                                    <li>Sensitivity to light</li>
                                    <li>Sensitivity to noise</li>
                                    <li>Feeling sluggish, hazy, foggy, or groggy</li>
                                    <li>Concentration or memory problems</li>
                                    <li>Confusion</li>
                                    <li>Does not “feel right”</li>
                                </ul>
                            </div>                                                
                        </div>
                    </div>
                    <div>
                        <h3 className="h3__roboto-w ">What todo if you think your child has a concussion?</h3>
                        <div className="">
                            
                            <ol className="p__list">
                                <li><b>Seek medical attention right away.</b> A health care professional with knowledge 
                                    in concussion management will be able to decide how serious the concussion is and 
                                    when it is safe for your child to return to sports.
                                </li>
                                <li><b>Keep your child out of play.</b> Concussions take time to heal. Don’t let your
                                    child/player return to play on the same day the injury occurred and until a health care
                                    professional says it’s OK. Children who return to play too soon – while the brain is
                                    still healing—risk a greater chance of having a second concussion. Second or later
                                    concussions can be very serious. They can cause permanent brain damage, affecting
                                    your child for a lifetime.</li>
                                <li><b>Tell your child’s coach about any recent concussion.</b> Coaches should know if your
                                    child had a recent concussion in ANY sport. Your child’s coach may not know about
                                    a concussion your child received in another sport or activity unless you tell the coach.
                                </li>
                                <li><b>Coaches shall report concussions immediately to Orion FC Board President and Director of Coaching. </b>
                                    It is the responsibility of the Coach or their Assistant Coach to 
                                    provide documentation from a licensed medical professional or parent/guardian in 
                                    order to return to practice/play. Understand every case is different and each will be 
                                    dealt with on a case by case basis.
                                </li>                                   
                            </ol>
                        </div>                
                    </div>
                    <OneColumnB
                        subtitle="Graduated return to play Protocol"
                        subheader=""
                        paragraph="
                        For athletes who have had a concussion, University of Iowa Sports Medicine recommends a multi-step recovery process known as 
                        “graduated return to play”. This process is performed under the supervision of a health care professional, such as a certified 
                        athletic trainer or your primary care physician. The process begins after the athlete has had no symptoms for at least 24 hours. 
                        Each step is performed a minimum of 24 hours after the previous step. This extends the full recovery process to at least five days. "
                    />
                    <div className="list">
                        <h3 className="h3__roboto-w ">The steps include:</h3>
                        <div className="">
                            
                            <ol className="p__list">
                                <li><b>Light aerobic activity —</b> walking, jogging, or exercise bike for a brief period of time.</li>
                                <li><b>Moderate activity —</b> moderate-intensity aerobic activity and moderate-intensity weight training.</li>
                                <li><b>Non-contact training drills —</b> high-intensity aerobic and weight-training 
                                routines and non-contact drills specific to the athlete’s sport.</li>
                                <li><b>Full-contact practice — </b>the athlete’s normal practice routine.</li>
                                <li><b>Return to competitive play</b></li>                                       
                            </ol>
                            <p className="p__opensans">An athlete who shows symptoms of concussion at any step of the process must rest for
                                 a minimum of 24 hours before returning to try that same step 
                                 again. This includes physical symptoms (headache, dizziness, blurred vision,
                                 etc.) as well as cognitive symptoms (loss of memory, inability to answer
                                 questions quickly, mood or behavior changes, etc.).
                                 </p>
                        </div>              
                    </div>
                    <div className="list">                        
                        <div className="list">
                            <h4 className="p__opensans-tryout">This graduated approach allows:</h4>
                            <ul className="p__list">
                                <li>a safe, gradual return to competition for the athlete</li>
                                <li>thorough monitoring of the athlete’s condition and progress by a trained health care professional</li>                    
                            </ul>
                        </div>                     
                    </div>
                     <div className="app__content">
                        <h1 className="h3_">Any questions can be directed to Orion FC Board</h1>
                        <PdfComponent url={ConcussionPolicyForm25} downloadName="ConcussionPolicyForm25.pdf" />
                    </div>
                </div>
            </div>
        <Footer />
    </div>
)}
export default Policies